export { Channel } from 'pusher-js';

// Global prefix for private/presence channels
const PRIVATE_PREFIX = 'private-';
const PRESENCE_PREFIX = 'presence-';
const PUBLIC_PREFIX = '';
// Types of channels
export type PusherChannelTypes =
  | 'aq'
  | 'apt'
  | 'convo'
  | 'userim'
  | 'notification'
  | 'ongoingTransfer'
  | 'listingCount'
  | 'onboardingApproval'
  | 'cs'
  | 'authupdate';

export const HEARTBEAT_PREFIX: PusherChannelTypes = 'aq';
export const APPOINTMENT_PREFIX: PusherChannelTypes = 'apt';
export const CONVO_ROOM_PREFIX: PusherChannelTypes = 'convo';
export const USER_CHANNEL_PREFIX: PusherChannelTypes = 'userim';
export const NOTIFICATION_PREFIX: PusherChannelTypes = 'notification';
export const ONGOING_TRANSFER_PREFIX: PusherChannelTypes = 'ongoingTransfer';
export const LISTING_COUNTS_PREFIX: PusherChannelTypes = 'listingCount';
export const ONBOARDING_APPROVAL_PREFIX: PusherChannelTypes =
  'onboardingApproval';
export const COUNT_SOCKET_PREFIX: PusherChannelTypes = 'cs';
export const AUTH_UPDATE_PREFIX: PusherChannelTypes = 'authupdate';

const GLOBAL_PREFIX_MAP: Record<PusherChannelTypes, string> = {
  aq: PRIVATE_PREFIX,
  apt: PRESENCE_PREFIX,
  convo: PRIVATE_PREFIX,
  userim: PRIVATE_PREFIX,
  notification: PRIVATE_PREFIX,
  ongoingTransfer: PRIVATE_PREFIX,
  listingCount: PRIVATE_PREFIX,
  onboardingApproval: PUBLIC_PREFIX,
  cs: PRIVATE_PREFIX,
  authupdate: PRIVATE_PREFIX,
};

const buildPusherChannel = (
  channelType: PusherChannelTypes,
  channelId: string,
) => `${GLOBAL_PREFIX_MAP[channelType]}${channelType}@${channelId}`;

export default buildPusherChannel;
